/**
 * Case-insensitive compare two strings using localeCompare function
 * @param {String} a
 * @param {String} b
 * @return {-1, 0, 1}
 */
export default (a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' })
